module.exports = __webpack_public_path__ + "img/globe.54b678e3.svg";